import styled from "styled-components";
import MUIInputAdornment from "@material-ui/core/InputAdornment";

const InputAdornment = styled(MUIInputAdornment)`
  margin-left: 0;
  margin-right: 8px;
`;

export default InputAdornment;
